<template>
	<section id="container" v-if="getOs" class="container2col">
        <!-- <div class="row">
            <div class="col-md-12">
                <h3 id="tituloChamados" ref>Chamados</h3>
            </div>
        </div> -->

        <div class="row" style="position: absolute; z-index: 2; margin-left: 15px">
            <div>
								<div :class="changeMode ? 'smallButtons' : 'bigButtons'" style="display: flex; align-items: center;">
										<button class="btn" v-on:click="formMode()" :class="changeMode && !edit ? 'buttonOn' : 'buttonOff'" >
												<i v-if="changeMode" class="fas fa-cogs" aria-hidden="true"></i>
												<i v-else class="fas fa-cogs" aria-hidden="true"></i>
												<span style="margin-left: 8px;" v-if="!changeMode">Novo Chamado</span>
										</button>

										<button class="btn" v-on:click="openHistory()" :class="changeMode && showHistory ? 'buttonOn' : 'buttonOff'" >
												<i v-if="changeMode" class="fas fa-history" aria-hidden="true"></i>
												<i v-else class="fas fa-history" aria-hidden="true"></i>
												<span style="margin-left: 8px;" v-if="!changeMode">Histórico de Chamados</span>
										</button>
                </div>
            </div>
        </div>
        <div class="row" style="margin-top: 45px;" >
            <div :class="changeMode ? 'col-md-7' : 'col-md-12'">
                <div id="table-container">
                    <occurrence-table
                        :update="updateTable"
                        v-on:updated="updateTable = false"
                        v-on:edit="formMode($event)"
                        :techList="technicianList"
                        :new="buttonOn">
                    </occurrence-table>
    	        </div>
            </div>
            <!-- <div class="col-md-5" style="align-self: center" :class="{isHidden: !changeMode}"> -->
							<div class="row" style="margin-top: 45px;">
								<div style="z-index: 3" :class="{isHidden: !changeMode}">
									<occurrence-form
											:chamadoEdit="edit"
											:techList="technicianList"
											v-on:updateForm="refreshTable();switchMode()">
									</occurrence-form>
								</div>
            </div>
            <!-- <div class='grid-column' :class="{isHidden: !changeMode}">
            </div> -->
        </div>


        <div id="occurrenceHistoryModal" style="z-index: 3">
            <occurrence-history
                :toggleHistory="showHistory"
                :techList="technicianList"
                v-on:closeHistory="closeHistory()">
            </occurrence-history>
        </div>
	</section>
</template>

<script>
import {mapGetters} from 'vuex';
import occurrenceForm from './occurrenceForm.vue';
import occurrenceHistory from './occurrenceHistory';
import occurrenceTable from './occurrenceTable';

export default {
    data(){
        return{
            edit: null,
            changeMode: false,
            protocol: "",
            showHistory: false,
            userId: "",
            updateTable: false,
            technicianList: [],
            buttonOn: false
        }
    },

    components:{
        occurrenceForm,
        occurrenceHistory,
        occurrenceTable,
    },

    computed:{
        ...mapGetters(['getAllOcorrence', 'occurrence','getChamados','getOs']),

	},

    methods:{
        formMode(data) {
            //EDIT
            this.buttonOn = false;
            if (data){
                this.edit = data;
                if(this.changeMode){
                    if (this.protocol == data.protocol){
                        this.switchMode();
                    }
                } else {
                    this.switchMode();
                }
                this.protocol = data.protocol;
            //CREATE
            } else {
                this.buttonOn = true;
                this.protocol = '';
                if (this.edit != null){
                    if (this.changeMode){
                        this.edit = null;
                    } else {
                        this.switchMode();
                        this.edit = null;
                    }
                } else {
                    this.switchMode();
                };
            };
        },

        closeHistory(){
            this.showHistory = !this.showHistory;
        },

        switchMode(){
            this.changeMode = !this.changeMode;
        },

        openHistory(){
            this.showHistory = !this.showHistory;
        },
        refreshTable(){
            this.updateTable = true;
        },
    },

    created(){
        axios.get("/dialer/userList").then(({data}) => {
            data.forEach(element => {
                this.technicianList.push({'value': element.id, 'text': element.name});
            });
        })
    }
}
</script>

<style scoped>
    .formMode {
        display:flex;
        /* grid-template-columns: 60% auto;
        grid-template-rows: 80vh;
        grid-gap: 10px; */
        flex-direction: column;
        margin: 1em;
        height: 70vh;
    }

    .row {
        margin: 0;
    }

    .col-md-12 {
        margin-left: 0 !important;
    }

    .isHidden {
        display: none;
    }

    .container2col {
        display:flex;
        /* grid-template-columns: 12fr;
        grid-template-rows: 80vh;
        grid-gap: 10px; */
        flex-direction: column;
        margin: 1em;
        height: 80vh;
    }

    .button-page{
        margin-top:0px;
        float:right;
        margin-right: 0.5em;
    }

    .no-border{
        border: hidden;
        background: none;
    }

    .col-md-12 {
        margin-left: 1em;
    }

		.smallButtons .btn i, .bigButtons .btn i {
				/* Ajusta o tamanho do ícone */
				font-size: 12px; /* Ou o tamanho que você preferir */
		}

		.smallButtons .btn span, .bigButtons .btn span {
				/* Ajusta o tamanho do texto */
				font-size: 12px; /* Ou o tamanho que você preferir */
				vertical-align: middle; /* Alinha verticalmente com o ícone */
		}

    .buttonOff {
        border: solid 2px #1c869a;
        border-radius: 15px;
        font-size: 12px;
        width: 200px;
        font-weight: 700;
        color: #1c869a;
        background-color: white;
        padding: 10px;
        margin: 5px;
        transition: 0.2s;
    }

    .buttonOff:hover {
        background-color: #358d9ec5;
        color: white
    }

    .buttonOn {
        border: solid 2px #1c869a;
        border-radius: 15px;
        font-size: 12px;
        width: 200px;
        font-weight: 700;
        color: white;
        background-color: #1c869a;;
        padding: 10px;
        margin: 5px;
    }


	@media screen and (max-width: 1489px) {

        .table-low-res{
            height: 33em;
            overflow: auto;
        }

	}
    @media screen and (max-width: 941px){
        .table-low-res{
            height: 30em;
            overflow: auto;
        }
    }

    #tituloChamados {
		line-height: 2;
		text-align: center;
        font-size: 34px;
		color: rgb(28,134,154);
	}

    #buttonGroup {
        position: absolute;
        display: flex
    }
</style>
